export enum UserType {
  USER = 'user', // regular user
  ORGANIZATION_TECHNICAL_USER = 'organization-technical-user', // used for api keys organization wide
}
